import { useEffect } from 'react'
import posthog from 'posthog-js'
import { useCookieConsent } from 'react-cookie-manager'

export function PostHogInitializer () {
  const { detailedConsent } = useCookieConsent()

  useEffect(() => {
    if (detailedConsent?.Analytics?.consented && import.meta.env.VITE_POSTHOG_API_KEY) {
      posthog.init(import.meta.env.VITE_POSTHOG_API_KEY, {
        api_host: import.meta.env.VITE_POSTHOG_API_URL,
        capture_pageview: false,
        loaded: posthog => {
          if (!import.meta.env.PROD) {
            posthog.opt_out_capturing()
          }
        }
      })
    } else {
      posthog.reset()
    }
  }, [detailedConsent?.Analytics?.consented])

  return null
}
